// extracted by mini-css-extract-plugin
module.exports = {"bottomnav":"bottom_bottomnav__1SxVp","bntab":"bottom_bntab__tkzqd","base":"bottom_base__dkahA"};